import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, handleFirestoreError, OperationType } from './firebase';

export type NotificationType = 'order' | 'facility' | 'status' | 'inventory';

export async function createNotification(
  title: string,
  message: string,
  type: NotificationType,
  referenceId?: string
) {
  const path = 'notifications';
  try {
    await addDoc(collection(db, path), {
      title,
      message,
      type,
      read: false,
      createdAt: serverTimestamp(),
      referenceId
    });
  } catch (error) {
    handleFirestoreError(error, OperationType.CREATE, path);
  }
}
